import { render, staticRenderFns } from "./IdCheckComponent.vue?vue&type=template&id=5c138dd0&scoped=true&"
import script from "./IdCheckComponent.vue?vue&type=script&lang=js&"
export * from "./IdCheckComponent.vue?vue&type=script&lang=js&"
import style0 from "./IdCheckComponent.vue?vue&type=style&index=0&id=5c138dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c138dd0",
  null
  
)

export default component.exports